import React, { useState, useEffect } from 'react';

const SearchFilter = ({ onFilterChange, initialFilters }) => {
  const [email, setEmail] = useState(initialFilters?.email || '');
  const [isActive, setIsActive] = useState(initialFilters?.isActive ?? null);
  
  // Apply filter changes when component mounts with initialFilters
  useEffect(() => {
    if (initialFilters) {
      setEmail(initialFilters.email || '');
      setIsActive(initialFilters.isActive ?? null);
    }
  }, [initialFilters]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleIsActiveChange = (value) => {
    setIsActive(value);
  };

  const handleApplyFilters = () => {
    const filters = {
      email: email.trim() || undefined,
      isActive: isActive !== null ? isActive : undefined
    };
    onFilterChange(filters);
  };

  const handleResetFilters = () => {
    setEmail('');
    setIsActive(null);
    
    // Explicitly send empty filters to parent component
    onFilterChange({
      email: undefined,
      isActive: undefined
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleApplyFilters();
    }
  };

  return (
    <div className="bg-white p-4 mb-4 rounded-lg shadow">
      <div className="flex flex-col space-y-4">
        <div>
          <label htmlFor="email-search" className="block text-sm font-medium text-gray-700 mb-1">
            Search by Email
          </label>
          <input
            id="email-search"
            type="text"
            value={email}
            onChange={handleEmailChange}
            onKeyDown={handleKeyDown}
            placeholder="Enter email..."
            className="w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[44px]"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Genius Status
          </label>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => handleIsActiveChange(true)}
              className={`px-4 py-3 rounded-md min-h-[44px] min-w-[80px] ${
                isActive === true 
                  ? 'bg-green-600 text-white' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
              aria-pressed={isActive === true}
            >
              Active
            </button>
            <button
              onClick={() => handleIsActiveChange(false)}
              className={`px-4 py-3 rounded-md min-h-[44px] min-w-[80px] ${
                isActive === false 
                  ? 'bg-red-600 text-white' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
              aria-pressed={isActive === false}
            >
              Inactive
            </button>
            <button
              onClick={() => handleIsActiveChange(null)}
              className={`px-4 py-3 rounded-md min-h-[44px] min-w-[80px] ${
                isActive === null 
                  ? 'bg-blue-600 text-white' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
              aria-pressed={isActive === null}
            >
              All
            </button>
          </div>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <button
            onClick={handleApplyFilters}
            className="px-4 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 min-h-[44px] flex-1 md:flex-none"
          >
            Apply Filters
          </button>
          <button
            onClick={handleResetFilters}
            className="px-4 py-3 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 min-h-[44px] flex-1 md:flex-none"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchFilter; 